import { Dialog, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import { CancelSubmitFormDialogActions } from 'framework/forms/CancelSubmitFormDialogActions';
import { FormTextField } from 'framework/forms/FormTextField';
import { handleFormResponse } from 'framework/forms/utils/handleFormResponse';
import { useFormSubmit } from 'framework/hooks/useFormSubmit';
import { exportColumnSelectionsCommand_new, IExportColumnSelectionModel } from 'gen/ApiClient';
import { IStrings } from 'localization/IStrings';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import * as yup from 'yup';

const createSchema = (strings: IStrings) => {
	return yup.object<IExportColumnSelectionModel>({
		name: yup.string().required(),
		columns: yup.mixed(),
	});
};

interface IProps extends DialogProps {
	view: string;
	columns: string[];
	confirm: (id: string) => void;
	cancel: VoidFunction;
}

export const ExportColumnSelectionModelForm = ({ view, columns, confirm, cancel, ...rest }: IProps) => {
	const strings = useLocalization();
	const [create, isSubmitting] = useFormSubmit(exportColumnSelectionsCommand_new);

	const handleSubmit = async (values: IExportColumnSelectionModel, helpers: FormikHelpers<IExportColumnSelectionModel>) => {
		const r = await create(view, values);
		if (handleFormResponse(r, helpers)) {
			confirm(r.result.objectId);
		}
	};

	return (
		<Formik<IExportColumnSelectionModel>
			validateOnMount
			initialValues={{
				columns: columns,
				name: '',
			}}
			validationSchema={createSchema(strings)}
			onSubmit={handleSubmit}>
			<Form>
				<Dialog
					fullWidth
					{...rest}>
					<DialogTitle>{strings.saveColumnSelection}</DialogTitle>
					<DialogContent
						className='df-col'
						dividers>
						<FormTextField<IExportColumnSelectionModel>
							name='name'
							label={strings.name}
						/>
					</DialogContent>
					<CancelSubmitFormDialogActions
						cancel={cancel}
						isSubmitting={isSubmitting}
						submitText={strings.save}
					/>
				</Dialog>
			</Form>
		</Formik>
	);
};
